import React from 'react';
import type { CustomGlyphProps } from '@atlaskit/icon/types';
import { token } from '@atlaskit/tokens';

const EpicIcon = (props: { primaryColor?: string } & CustomGlyphProps) => (
	<svg
		width="24"
		height="24"
		viewBox="-3 -3 22 22"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		data-testid={props['data-testid']}
	>
		<g clipPath="url(#clip0_2056_311)">
			<path
				d="M13.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V13.7143C0 14.9767 1.02335 16 2.28571 16H13.7143C14.9767 16 16 14.9767 16 13.7143V2.28571C16 1.02335 14.9767 0 13.7143 0Z"
				fill={props.primaryColor || '#904EE2'}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.3408 7.72169L11.3385 7.71712C11.3911 7.63141 11.4288 7.53655 11.4288 7.42798C11.4288 7.11255 11.1728 6.85655 10.8574 6.85655H8.00023V3.99941C8.00023 3.68398 7.74423 3.42798 7.4288 3.42798C7.23223 3.42798 7.0688 3.53312 6.96594 3.68284C6.93394 3.72969 6.90766 3.77769 6.89051 3.83141L4.66423 8.27026L4.66651 8.27369C4.61166 8.36169 4.57166 8.45998 4.57166 8.57084C4.57166 8.88741 4.82766 9.14226 5.14308 9.14226H8.00023V11.9994C8.00023 12.316 8.25623 12.5708 8.57166 12.5708C8.77623 12.5708 8.94766 12.4577 9.04937 12.2954L9.0528 12.2965L9.06766 12.2668C9.08023 12.2428 9.09394 12.2211 9.10308 12.196L11.3408 7.72169Z"
				fill={token('color.icon.inverse', 'white')}
			/>
		</g>
	</svg>
);

export default EpicIcon;
